import React from 'react';
import styled from 'styled-components';
import PhoneInput from 'react-phone-number-input';
import {tabletWidth} from '../mixins';


const StyledInputWrap = styled.div`
  width: 65%;
  position: relative;
  
   @media screen and (max-width: ${tabletWidth}) {
      width: 100%;
  }
`


const PhoneInputComp = ({phone, setPhone, country}) => {
    return (
        <StyledInputWrap>
            <PhoneInput
                defaultCountry={country || 'US'}
                international={true}
                withCountryCallingCode={true}
                placeholder="Phone number"
                value={phone}
                onChange={setPhone}
                id='phone-input'/>
        </StyledInputWrap>
    )
};

export default PhoneInputComp;